import swiperUtil from '../utils/swiper-util';

export default (node) => {
  /**
   * Data + elements
   */
  let swiper = null;
  const slides = node.querySelectorAll('[data-slide]');
  const nextButtons = node.querySelectorAll('[data-next]');
  const prevButtons = node.querySelectorAll('[data-prev]');

  /**
   * Functions
   */
  const handleReadMoreClick = (readMoreButton, quote) => {
    const readMoreText = readMoreButton.dataset.readMore;
    const readLessText = readMoreButton.dataset.readLess;

    if (quote.classList.contains('line-clamp-3')) {
      quote.classList.remove('line-clamp-3');
      readMoreButton.textContent = readLessText;
      return;
    }

    quote.classList.add('line-clamp-3');

    readMoreButton.textContent = readMoreText;
  };

  const handleSlideNext = () => {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const readMoreButton = currentSlide.querySelector(
      '[data-read-more-button]'
    );
    const quote = currentSlide.querySelector('[data-quote]');

    if (
      !quote.classList.contains('line-clamp-3') &&
      !readMoreButton.classList.contains('hidden')
    ) {
      handleReadMoreClick(readMoreButton, quote);
    }
    swiper.slideNext();
  };

  const handleSlidePrev = () => {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const readMoreButton = currentSlide.querySelector(
      '[data-read-more-button]'
    );
    const quote = currentSlide.querySelector('[data-quote]');

    if (
      !quote.classList.contains('line-clamp-3') &&
      !readMoreButton.classList.contains('hidden')
    ) {
      handleReadMoreClick(readMoreButton, quote);
    }

    swiper.slidePrev();
  };

  /**
   * Init
   */
  const init = () => {
    swiper = swiperUtil(node, {
      loop: true,
      spaceBetween: 24,
      autoHeight: false,
      breakpoints: {
        800: {
          autoHeight: true,
        },
      },
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', handleSlideNext);
    });

    prevButtons.forEach((button) => {
      button.addEventListener('click', handleSlidePrev);
    });

    slides.forEach((slide) => {
      const quote = slide.querySelector('[data-quote]');

      const isClamped = quote.clientHeight < quote.scrollHeight;

      if (isClamped) {
        const readMoreButton = slide.querySelector('[data-read-more-button]');

        readMoreButton.classList.remove('hidden');

        readMoreButton.addEventListener('click', () =>
          handleReadMoreClick(readMoreButton, quote)
        );
      }
    });
  };

  init();
};
